import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const ADMIN_TOKEN_KEY = "fv_admin_token";
// sessionStorage: cleared when the tab closes, not shared across tabs — smaller exposure window than localStorage.
export const getAdminToken = () => sessionStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => sessionStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => sessionStorage.removeItem(ADMIN_TOKEN_KEY);
export const withToken = (path) => `${API}${path}${path.includes("?") ? "&" : "?"}token=${encodeURIComponent(getAdminToken() || "")}`;

api.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const hadToken = !!err.config?.headers?.Authorization;
    if (err.response?.status === 401 && hadToken) {
      clearAdminToken();
      window.dispatchEvent(new Event("fv-admin-logout"));
    }
    return Promise.reject(err);
  }
);

export const apiError = (err, fallback = "Échec") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || fallback;
};
